'use strict';

exports.__esModule = true;
exports.isFlexSupported = isFlexSupported;
function isFlexSupported() {
  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
    var documentElement = window.document.documentElement;

    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
  }
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./~/rc-steps/lib/utils.js
// module id = 892
// module chunks = 0 1